import React from 'react';
import { r } from './helpers';
import LegacyPortalRedirect, { RiderLegacyRedirect } from '../../components/LegacyPortalRedirect';

/** Redirect legacy path-based rider URLs to rider-{slug} subdomain (v2 app). */
export function RiderLegacyPathRedirects() {
  return (
    <>
      {r('/rider', <LegacyPortalRedirect portal="rider" />)}
      {r('/rider/*', <LegacyPortalRedirect portal="rider" />)}
      {r('/rider_v2', <RiderLegacyRedirect />)}
      {r('/rider_v2/*', <RiderLegacyRedirect />)}
    </>
  );
}